// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"48a62300","592":"f403d30c","615":"3cf3a954"}[chunkId] + ".chunk.css";
};